import {CommonModule} from '@angular/common';
import {Component, ViewEncapsulation} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';

import {BasicPlanUpgradeDialogComponent} from './basic-plan-upgrade-dialog.component';

@Component({
  selector: 'app-locked-jaine',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './locked-jaine.component.html',
  styleUrl: './locked-jaine.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class LockedJaineComponent {
  constructor(private readonly dialog: MatDialog) {}

  openDialog(): void {
    this.dialog.open(BasicPlanUpgradeDialogComponent, {
      data: {source: 'JAINE'},
      maxWidth: '95vw',
      width: '520px'
    });
  }
}
